/* eslint-disable no-undef */
import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getPurchaseOrderReport = async (
  token,
  page = 1,
  per_page = 50,
  start_date = "",
  end_date = "",
  type = ""
) => {
  const params = new URLSearchParams({ page, per_page });
  if (start_date) params.append("start_date", start_date);
  if (end_date) params.append("end_date", end_date);
  if (type) params.append("type", type);

  try {
    const response = await fetch(
      `${BASE_URL}/api/v1/pharmacy/purchase_orders/purchase_items?${params.toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "Something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "Something went wrong");
  }
};
